import React from 'react';
import { styled, Caption, Title, SubTitle } from '@teko/ds-desktop';
import { formatCurrency } from '../../helpers/number.es.js';

const ProductPrice = ({
  supplierRetailPrice,
  latestPrice,
  discountPercent,
  textColor = "primary500",
  align = "start",
  size = "m",
  className,
  priceRange
}) => {
  const formattedRetailPrice = formatCurrency(supplierRetailPrice);
  const formattedLatestPrice = formatCurrency(latestPrice);
  let renderedRetailPrice, renderedDiscount;
  const renderedLatestPrice = () => {
    if (!priceRange) {
      return size === "l" ? /* @__PURE__ */ React.createElement(Title, {
        level: 2,
        color: textColor,
        weight: "bold"
      }, formattedLatestPrice) : /* @__PURE__ */ React.createElement(SubTitle, {
        level: 1,
        color: textColor
      }, formattedLatestPrice);
    }
    const formattedMinPrice = formatCurrency(priceRange.min, false);
    const formattedMaxPrice = formatCurrency(priceRange.max);
    return size === "l" ? /* @__PURE__ */ React.createElement(StyledTitle, {
      level: 2,
      color: textColor,
      weight: "bold",
      line: 1
    }, formattedMinPrice, " - ", formattedMaxPrice) : /* @__PURE__ */ React.createElement(StyledSubTitle, {
      level: 1,
      color: textColor,
      line: 1
    }, formattedMinPrice, " - ", formattedMaxPrice);
  };
  switch (size) {
    case "l":
      renderedRetailPrice = /* @__PURE__ */ React.createElement(StyledRetailPrice, {
        level: 1,
        color: "textSecondary"
      }, formattedRetailPrice);
      renderedDiscount = /* @__PURE__ */ React.createElement(Caption, {
        level: 1,
        color: textColor
      }, discountPercent);
      break;
    default:
      renderedRetailPrice = /* @__PURE__ */ React.createElement(StyledRetailPrice, {
        level: 1,
        color: "textSecondary"
      }, formattedRetailPrice);
      renderedDiscount = /* @__PURE__ */ React.createElement(Caption, {
        level: 1,
        color: textColor
      }, discountPercent);
      break;
  }
  const isShowRetailPrice = supplierRetailPrice && supplierRetailPrice > latestPrice;
  const isShowDiscount = !!discountPercent;
  return /* @__PURE__ */ React.createElement(ProductPriceWrapper, {
    align,
    className
  }, renderedLatestPrice(), (isShowRetailPrice || isShowDiscount) && /* @__PURE__ */ React.createElement(StyledDiscount, null, isShowRetailPrice && renderedRetailPrice, isShowDiscount && renderedDiscount));
};
const ProductPriceWrapper = styled.div(({ align }) => `
  display: flex;
  flex-direction: column;
  align-items: ${align};
  height: 2.5rem;
`);
const StyledRetailPrice = styled(Caption)(({ theme }) => `
    text-decoration: line-through;
    margin-right: ${theme.spacing.s4};
`);
const StyledDiscount = styled.div`
  display: flex;
  height: 1rem;
`;
const StyledTitle = styled(Title)`
  word-break: break-all;
`;
const StyledSubTitle = styled(SubTitle)`
  word-break: break-all;
`;

export { ProductPrice };
